import React from 'react';

const CostCalculatorHero: React.FC = () => {
  return (
    <div className="bg-gradient-to-r from-indigo-600 to-blue-600 text-white py-16">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            AI API Cost Calculator - Compare 1000+ LLM Models
          </h1>
          <p className="text-xl md:text-2xl mb-4 text-blue-100">
            Calculate and compare costs across OpenAI GPT-4, Claude, Gemini, Llama, and 1000+ other AI models
          </p>
          <p className="text-lg text-blue-100 mb-8">
            Make informed decisions about your AI API usage with real-time pricing data from all major providers including OpenAI, Anthropic, Google, AWS, Azure, Mistral, and more.
          </p>
          <div className="flex flex-wrap justify-center gap-4 text-sm">
            <div className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full">
              ✓ Real-time pricing data
            </div>
            <div className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full">
              ✓ 1000+ AI models
            </div>
            <div className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full">
              ✓ Cost optimization insights
            </div>
            <div className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full">
              ✓ Free to use
            </div>
          </div>
          
          <div className="mt-6">
            <p className="text-white/90 text-base mb-4">
              📚 New to AI tokens and pricing?{' '}
              <a 
                href="/blog/understanding-ai-tokens-and-api-costs" 
                className="text-white font-semibold underline hover:text-blue-200 transition-colors"
              >
                Read our complete guide
              </a>
              {' '}to understand how AI API costs are calculated.
            </p>
            
            {/* New Tool Highlights */}
            <div className="grid md:grid-cols-2 gap-4 mt-8 max-w-3xl mx-auto">
              <a 
                href="/token-calculator" 
                className="bg-white/10 backdrop-blur-sm p-6 rounded-xl hover:bg-white/20 transition-all group text-left"
              >
                <div className="flex items-start gap-3">
                  <div className="text-3xl">🔢</div>
                  <div>
                    <h3 className="font-bold text-lg mb-1 group-hover:text-blue-200 transition-colors">
                      Token Calculator
                    </h3>
                    <p className="text-sm text-blue-100">
                      Test your prompts and see exact token usage with live AI responses
                    </p>
                  </div>
                </div>
              </a>
              
              <a 
                href="/provider-selector" 
                className="bg-white/10 backdrop-blur-sm p-6 rounded-xl hover:bg-white/20 transition-all group text-left"
              >
                <div className="flex items-start gap-3">
                  <div className="text-3xl">🎯</div>
                  <div>
                    <h3 className="font-bold text-lg mb-1 group-hover:text-blue-200 transition-colors">
                      Provider Selector
                    </h3>
                    <p className="text-sm text-blue-100">
                      Get AI-powered recommendations for the best provider for your use case
                    </p>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CostCalculatorHero;
